import {GraphQLResolveInfo} from "graphql";
import {visitArguments} from "../../utils/resolve";

export default (processors: Object) => async (resolve, parent, args, context, info: GraphQLResolveInfo) => {
    return await resolve(parent, await visitArguments(args, info, context, processors), context, info);
}
